import { ObjectMap } from '@df/common';
/* eslint-disable @typescript-eslint/no-explicit-any */
const reviver = (_key, value) => {
    if (value !== null && typeof value === 'object' && 'dataType' in value) {
        if (value.dataType === 'Map') {
            return new Map(value.value);
        }
        if (value.dataType === 'ObjectMap') {
            return new ObjectMap(value.value);
        }
        if (value.dataType === 'Set') {
            return new Set(value.value);
        }
    }
    // If the value is not a Map, ObjectMap, or Set, return it as is
    return value;
};
export { reviver };
